<template>
  <div>
    <ul class="list">
      <li
        v-for="item in articleList"
        :key="item.id"
        :class="{ 'top-border': curNav === 1 }"
        @click="goDetails(item)"
      >
        <p class="title-ch">{{ item["paperTitle"] }}</p>
        <p class="title-en">{{ item["spare1"] }}</p>
        <div class="info">
          <p>
            <span class="label">作者：</span>
            <span class="value">{{ item["authorName"] }} </span>
          </p>
          <p>
            <span class="label">年度：</span>
            <span class="value">{{ item["years"] }}年</span>
          </p>
          <p>
            <span class="label">期号：</span>
            <span class="value">第{{ item["issue"] }}期 </span>
          </p>
          <p v-if="item.columnId">
            <span class="label">栏目：</span>
            <span class="value">{{ item["columnId"] }}</span>
          </p>
        </div>
      </li>
    </ul>
    <p v-if="total * 1 === 0" class="no-data">暂无数据</p>
    <div v-if="total > 0" class="pagination">
      <el-pagination
        :page-size="pageSize"
        :total="total"
        background
        layout="prev, pager, next"
        @size-change="getList"
        @current-change="getList"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "Article",
  props: {
    articleList: {
      type: Array,
      default: () => [],
    },
    pageSize: {
      type: [Number, String],
      default: 10,
    },
    total: {
      type: [Number, String],
      default: 0,
    },
    page: {
      type: Object,
      default: () => {
        return {
          total: 0,
          pageNo: 1,
          pageSize: 10,
        };
      },
    },
    curNav: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {
    getList(page) {
      this.$emit("changePage", page);
    },
    goDetails(item) {
      this.$router.push({
        name: "journalDetails",
        query: { id: item.id, curNav: this.curNav },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  margin-top: 20px;

  li {
    position: relative;
    padding: 20px 50px;

    .title-ch {
      font-size: 16px;
      color: #333333;
      line-height: 25px;
      word-wrap: break-word;
      text-align: justify;
    }

    .title-en {
      font-size: 16px;
      color: #666666;
      line-height: 25px;
      word-wrap: break-word;
      text-align: justify;
    }

    .info {
      display: flex;
      align-items: center;

      .label {
        color: #333333;
        font-size: 14px;
        line-height: 25px;
      }

      .value {
        color: #999999;
        margin-right: 20px;
        font-size: 14px;
        line-height: 25px;
      }
    }

    &.top-border {
      &:first-child {
        &:before {
          position: absolute;
          top: 0px;
          left: 50px;
          content: "";
          width: 1080px;
          height: 1px;
          background: #e1e8f6;
        }
      }
    }

    &:after {
      position: absolute;
      bottom: -1px;
      left: 50px;
      content: "";
      width: 1080px;
      height: 1px;
      background: #e1e8f6;
    }

    &:hover {
      background: #e1e8f6;

      &:after {
        display: none;
      }

      &:before {
        display: none;
      }

      .title-ch {
        color: #0000d6;
      }

      cursor: pointer;
    }
  }
}

.pagination {
  text-align: center;
  padding: 40px 0;
}

.no-data {
  font-size: 14px;
  color: #999999;
  line-height: 200px;
  text-align: center;
}
</style>
